import { Modal, Table } from "antd";
import { useSelector } from "react-redux";

const referenceColumns = [
  {
    title: "DFI ranges",
    dataIndex: "DFI_ranges",
    key: "DFI_ranges",
  },
  {
    title: "Sperm chromatin dispersion",
    dataIndex: "sperm_chromatin_dispersion",
    key: "sperm_chromatin_dispersion",
  },
];

const referenceData = [
  {
    key: "1",
    DFI_ranges: "0-30%",
    sperm_chromatin_dispersion: "Within acceptable limit",
  },
  {
    key: "1",
    DFI_ranges: "31-60%",
    sperm_chromatin_dispersion: "Equivocal limit",
  },
  {
    key: "1",
    DFI_ranges: "61%-90%",
    sperm_chromatin_dispersion: "Abnormal limit",
  },
];

const DNAModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Sperm DFI Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID</div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Patient Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
                <div>Partner</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
                <div>Partner Age</div>
                <div>{activePatientJourneyModuleDetails?.partner_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Patient Registration & Basic info from patient
              </div>
              <div className="details-table">
                <div>Male Partner</div>
                <div>{activePatientJourneyModuleDetails?.male_partner}</div>
                <div>Age (Male)</div>
                <div>{activePatientJourneyModuleDetails?.age_male}</div>
                <div>Female Partner</div>
                <div>{activePatientJourneyModuleDetails?.female_partner}</div>
                <div>Age (Female)</div>
                <div>{activePatientJourneyModuleDetails?.age_female}</div>
                <div>Pt. ID</div>
                <div>{activePatientJourneyModuleDetails?.pt_id}</div>
                <div>Collection</div>
                <div>{activePatientJourneyModuleDetails?.collections}</div>
                <div>Collections Other</div>
                <div>
                  {activePatientJourneyModuleDetails?.collections_other}
                </div>
                <div>Complete Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.complete_collection}
                </div>
                <div>Rec.No.</div>
                <div>{activePatientJourneyModuleDetails?.rec_no}</div>
                <div>Date</div>
                <div>{activePatientJourneyModuleDetails?.date}</div>
                <div>Referring clinic/clinician</div>
                <div>{activePatientJourneyModuleDetails?.refer_clinic}</div>
                <div>Abstinence Period (Days)</div>
                <div>
                  {activePatientJourneyModuleDetails?.abstinance_period}
                </div>
                <div>Method Of Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.method_collection}
                </div>
                <div>Collection time(CT)</div>
                <div>{activePatientJourneyModuleDetails?.collection_time}</div>
                <div>Assay time (AT)</div>
                <div>{activePatientJourneyModuleDetails?.assay_time}</div>
                <div>Ejaculate volume</div>
                <div>{activePatientJourneyModuleDetails?.ejaculate_volume}</div>
                <div>Liquification Time</div>
                <div>
                  {activePatientJourneyModuleDetails?.liquification_time}
                </div>
                <div>Batch</div>
                <div>{activePatientJourneyModuleDetails?.batch_no}</div>
                <div>Kit</div>
                <h5 className="m-0">Sperm Chromatin Dispersion</h5>
                <div>Expiry Date</div>
                <div>{activePatientJourneyModuleDetails?.expiry_date}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Reference value</div>
              <div className="details-table">
                <div>Interpretation</div>
                <div>{activePatientJourneyModuleDetails?.interpretation}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
                <div>Done by</div>
                {/* <div>{activePatientJourneyModuleDetails?.done_by}</div> */}
              </div>
            </div>
          </div>
          <div className="table_wrapper mt-3">
            <h3>Subsequent Semen Analysis</h3>
          </div>

          <div className="custom_table_wrap">
            <div className="table-responsive ">
              <table>
                <thead>
                  <tr>
                    <th>DNA fragmentation / No. of sperms evaluated</th>
                    <th className="text-center">500</th>
                    <th className="text-center">100</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>No. of sperms with Large halo</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>No. of sperms with Medium halo</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>No. of sperms with small halo</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>No. of sperms without halo</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>No. of degraded sperm</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="table_custom_footer mt-3">
            <div className="row g-3 align-items-center">
              <div className="col-sm-6">
                <h5 className="m-0">DNA fragmentation index (DFI) (%)</h5>
              </div>
              <h5 className="col-sm-6 text-sm-end m-0">-</h5>
            </div>
          </div>

          <div className="cmn_table_wrap table_wrapper mb-2">
            <h3 className="table-title">Reference value</h3>

            <Table
              columns={referenceColumns}
              dataSource={referenceData}
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DNAModal;
